// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3oiRz","insightsList":"newBusinessInsightsMenu_insightsList__1_mpx","active":"newBusinessInsightsMenu_active__3L7lX"};